import React from 'react';
import { isCordova } from 'utils/platform';

const CSS = require('./AppBottomPushDown.module.scss');

function AppBottomPushDown() {
  if (!isCordova()) {
    return null;
  }
  return <div className={CSS.PushDown} />;
}

export default AppBottomPushDown;
